import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { HeaderCharmType, getActiveCharm } from 'owa-header-store';
import { ActivityFeedPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { getUnseenItemsCount } from 'owa-activity-feed/lib/store/unseenItemsSelector';
import { ACTIVITYFEED_FLEXPANE_ID } from '../constants';
import { openFlexPane, closeFlexPane } from 'owa-suite-header-apis';
import { isFeatureEnabled } from 'owa-feature-flags';
import { toggleCharm } from 'owa-header-store';
import strings from 'owa-strings/owa-common-strings';

@observer
export default class ActivityFeedCharm extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <HeaderCharm
                    key="activityfeed"
                    icons={{ iconName: ControlIcons.Ringer }}
                    ariaLabel={strings.activityFeedTitle}
                    behavior={{
                        paneComponent: isFeatureEnabled('fwk-o365shellheader')
                            ? null
                            : ActivityFeedPane,
                        charm: HeaderCharmType.ActivityFeedCharm,
                        onClick: this.onActivityFeedCharmClick,
                    }}
                    getBadgeCount={getUnseenItemsCount}
                />
            </div>
        );
    }

    private onActivityFeedCharmClick = () => {
        let isCurrentlyActive = getActiveCharm() === HeaderCharmType.ActivityFeedCharm;
        if (!isFeatureEnabled('fwk-o365shellheader')) {
            toggleCharm(HeaderCharmType.ActivityFeedCharm);
        } else if (isFeatureEnabled('fwk-o365shellheader-responsive')) {
            // In responsive mode, custom controls need to be hooked up to FlexPanes manually
            if (!isCurrentlyActive) {
                openFlexPane(ACTIVITYFEED_FLEXPANE_ID);
            } else {
                closeFlexPane(ACTIVITYFEED_FLEXPANE_ID);
            }
        }
    };
}
